import type { CSSProperties } from "react";
import { PHOSPHOR } from "./phosphor-icons";
import type { IconWeights } from "./phosphor-icons";
// Oktober brand bits used across the app: the logo and the icon set. Ported from oktober-os/components/oktober.tsx.

export function OktoberLogo({ height = 18, color }: { height?: number; color?: string }) {
  return (
    <span
      aria-label="Oktober"
      title="Oktober"
      style={{
        display: "inline-block",
        height,
        width: height * (1356 / 324),
        background: color || "var(--om-ink)",
        WebkitMaskImage: "url(/brand/logo-oktober.svg)",
        maskImage: "url(/brand/logo-oktober.svg)",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
      }}
    />
  );
}

/** "OKT", the short mark for tight spots (the collapsed sidebar). */
export function OktoberMark({ height = 18, color }: { height?: number; color?: string }) {
  return (
    <span
      aria-label="Oktober"
      title="Oktober"
      style={{
        display: "inline-block",
        height,
        width: height * (570.2 / 323.8),
        background: color || "var(--om-ink)",
        WebkitMaskImage: "url(/brand/logo-ok.svg)",
        maskImage: "url(/brand/logo-ok.svg)",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}

// ── Icons: Phosphor (phosphoricons.com), built by scripts/build-phosphor-icons.mjs ──

export type IconName = keyof typeof PHOSPHOR;
/** Regular everywhere; fill for active and selected things; bold for ticks; duotone for tiles. */
export type IconWeight = "regular" | "fill" | "bold" | "duotone";

export function Icon({
  name,
  size = 16,
  color = "currentColor",
  weight = "regular",
  className,
  style,
}: {
  name: IconName;
  size?: number;
  color?: string;
  /** Falls back to regular when the icon wasn't built in that weight. */
  weight?: IconWeight;
  className?: string;
  style?: CSSProperties;
}) {
  const icon: IconWeights = PHOSPHOR[name];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill={color}
      className={className}
      style={style}
      aria-hidden
      focusable="false"
      // Our own generated paths (see phosphor-icons.ts), never user input
      dangerouslySetInnerHTML={{ __html: icon[weight] ?? icon.regular }}
    />
  );
}
